import { styled } from "@mui/material"

const LeftContent = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  flex: 1,
}))

export default LeftContent
